import { supabase } from '../supabase/supabase';

const invokeAdminUserFunction = async (body) => {
  const { data, error } = await supabase.functions.invoke(
    'admin-manage-user',
    { body }
  );

  if (error) {
    let message = error.message;
    try {
      const response = await error.context?.json?.();
      message = response?.error || message;
    } catch {
      // Fall back to the Supabase Functions client error.
    }
    throw new Error(message || 'Unable to manage this user account.');
  }

  if (data?.error) throw new Error(data.error);
  return data;
};

export const fetchAdminUserStatuses = async () => {
  const result = await invokeAdminUserFunction({ action: 'list_statuses' });
  return result.statuses || [];
};

export const setAdminUserDisabled = (userId, disabled) =>
  invokeAdminUserFunction({
    action: 'set_disabled',
    user_id: userId,
    disabled
  });

export const sendAdminPasswordResetEmail = async (email) => {
  const { error } = await supabase.auth.resetPasswordForEmail(email);
  if (error) throw error;
};
